import { GoogleMaps, Marker } from 'react-google-maps';
import React, { Component, PropTypes } from 'react';
const google = window.google;

class SimpleMap extends Component {

  constructor() {
    super();
    this.state = {
      googleMapsIsReady: false,
    };
  }

  componentWillMount() {
    // we are using google map's API and we have to wait for each api to load.
    window.initializedGoogleMap.listener(() => {
      this.setState({
        googleMapsIsReady: true,
      });
    });
  }

  render() {
    if (!this.state.googleMapsIsReady) {
      return (
        <div> Loading... </div>
      );
    }

    const { googleMapsApi, ...otherProps } = this.props;
    const coordinates = this.props.coordinates || [-33.867486900000000000, 151.206990200000060000];
    return (
      <GoogleMaps
        containerProps={{
          ...otherProps,
          style: {
            height: '100%',
            position: 'absolute',
            top: '0',
            bottom: '0',
            left: '0',
            right: '0',
          },
        }}
        ref="map"
        googleMapsApi={
          google ? google.maps : null
        }
        zoom={12}
        center={new google.maps.LatLng(coordinates[0], coordinates[1] - 0.05)}
      >
        <Marker position={new google.maps.LatLng(coordinates[0], coordinates[1])} />
      </GoogleMaps>
    );
  }
}

SimpleMap.propTypes = {
  coordinates: PropTypes.array,
  googleMapsApi: PropTypes.object,
};

export default SimpleMap;



// WEBPACK FOOTER //
// ./src/app/components/map.jsx